import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function FloatingButtons() {
  return (
    <div className="fixed bottom-24 right-4 md:right-6 z-50 flex flex-col items-center gap-3">
      {/* LINE Button */}
      <a
        href="https://lin.ee/wpeGAKJ"
        target="_blank"
        rel="nofollow noreferrer"
        aria-label="加入官方 LINE"
        className="group relative w-12 h-12 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 transition-all duration-200 cursor-pointer"
      >
        <i className="ri-line-fill text-white text-2xl" />
        {/* Tooltip */}
        <span className="absolute right-14 bg-gray-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
          加入官方 LINE
          <span className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1.5 border-4 border-transparent border-l-gray-900" />
        </span>
      </a>
    </div>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <FloatingButtons />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
